import React from 'react';
import { useConfig } from '../context/ConfigContext';
import useMenuWebSocket from '../hooks/useMenuWebSocket';
import './IceCreamProductsTV-V2.css';
import fondoProductos from '../assets/FondoProductosFinal.webp';
import logoMiPiace from '../assets/LogoMiPiace.webp';

const IceCreamProductsTVV2 = () => {
    const { config } = useConfig();
    
    // Hook WebSocket para actualizaciones en tiempo real
    const {
        iceCreamProducts,
        isConnected,
        isLoading,
        error,
        reconnect
    } = useMenuWebSocket(config?.shopBranchId);

    const formatPrice = (price) => {
        const numericPrice = parseFloat(price);
        return new Intl.NumberFormat('es-AR', {
            style: 'currency',
            currency: 'ARS',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(numericPrice);
    };

    if (isLoading) {
        return (
            <div 
                className="icecream-tv-v2-container"
                style={{
                    backgroundImage: `url(${fondoProductos})`
                }}
            >
                <img src={logoMiPiace} alt="Mi Piace" className="icecream-tv-v2-logo" />
                <div className="icecream-tv-v2-loading">
                    <div className="icecream-tv-v2-loading-spinner"></div>
                    <p>Conectando con el servidor...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div 
                className="icecream-tv-v2-container"
                style={{
                    backgroundImage: `url(${fondoProductos})`
                }}
            >
                <img src={logoMiPiace} alt="Mi Piace" className="icecream-tv-v2-logo" />
                <div className="icecream-tv-v2-error">
                    <p>❌ {error}</p>
                    <p className="icecream-tv-v2-connection-status">
                        {isConnected ? '🟢 Conectado' : '🔴 Desconectado'}
                    </p>
                    <button onClick={reconnect} className="icecream-tv-v2-retry-button">
                        Reconectar
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div 
            className="icecream-tv-v2-container"
            style={{
                backgroundImage: `url(${fondoProductos})`
            }}
        >
            <img src={logoMiPiace} alt="Mi Piace" className="icecream-tv-v2-logo" />
            <div className="icecream-tv-v2-content">
                {iceCreamProducts.length === 0 ? (
                    <div className="icecream-tv-v2-empty">
                        <p>No hay productos de helados disponibles</p>
                    </div>
                ) : (
                    <div className="icecream-tv-v2-products-grid">
                        {[...iceCreamProducts]
                            .sort((a, b) => parseFloat(b.price) - parseFloat(a.price))
                            .map((product) => (
                            <div key={product.id} className="icecream-tv-v2-product-card">
                                <div className="icecream-tv-v2-product-info">
                                    <h3 className="icecream-tv-v2-product-name">{product.name}</h3>
                                    <div className="icecream-tv-v2-product-price">
                                        <span className="icecream-tv-v2-price-amount">
                                            {formatPrice(product.price)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default IceCreamProductsTVV2; 